import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { openPlaceOrderDialog, openWatchlistPrompt, openOrderConfirm } from '@/actions/app';
import { stockActions } from '@/actions/trading/stock.action';
import { accountActions } from '@/actions/trading';
import RefreshIcon from '@/assets/images/icons/icon_refresh.png';
import SearchIcon from '@/assets/images/icons/nav_icon_search.png';
import WatchlistIcon from '@/assets/images/icons/quote_icon_watchlist.png';
import '../../assets/styles/components/instrument/instrument.scss';
import { Icons, SERVICES_RESP , history} from '@/configurations';
import { APP_LANGUAGE_SUPPORTS, LOADING_TYPE, ORDER_TYPE, REFRESH_DATA } from '@/constants/app';
import { VARIABLES_CONFIGS } from '@/constants/win-vest';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import { Converter, formatFunctions, utilsFunction } from '@/helpers/functions';
import Dropdown from '@/components/Dropdown/Dropdown';
import Tips from '@/components/Tips/Tips';
import BidAsk from './BidAsk';
import InstrumentIndex from '@/components/Instrument/InstrumentIndex';
import PlaceOrderOption from './PlaceOrderOption';
import InstrumentECharts from '@/components/@charting/InstrumentECharts'
import { userActions } from '@/actions/user';
import WatchlistAddIcon from '@/assets/images/icons/nav_search_icon_watchlist_normal.png';
import SearchWatchlistIcon from '@/assets/images/icons/nav_search_icon_watchlist_hit.png';
import { getElementWidthHeightById } from '@/helpers/global';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { forumActions } from '@/actions/forum';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import { openAAStockDisclaimerDialog } from '@/actions/app/dialog.action'
import { WINVEST_PARAMS_JSON_FLAG } from '@/constants/win-vest' 
import { keyDownFunctions, accessibilityFunctions } from '@/helpers/functions';

const QUOTE_TAB = 'quote_tab';
const PROFILE_TAB = 'profile_tab';
const riskDisclosureHrefs = window?.config?.companyOptions?.riskDisclosure
const importantNoticeHrefs = window?.config?.companyOptions?.importantNotice

class Instrument extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bullSum:0.00,
      bearSum:0.00,
      bearBgColor:null,
      bullBgColor:null,
      stateBearBgColor:
      [
        {
            "SDbgColor": "#AF2D30",
            "SDValue": "0.00",
            "name": "common_bear_ultra_block"
        },
        {
            "SDbgColor": "#B00A32",
            "SDValue": "0.00",
            "name": "common_bear_block"
        },
        {
            "SDbgColor": "#D75153",
            "SDValue": "0.00",
            "name": "common_bear_retail"
        }
    ],
      stateBullBgColor:[
        {
            "SDbgColor": "#3B6953",
            "SDValue": "0.00",
            "name": "common_bull_ultra_block"
        },
        {
            "SDbgColor": "#478A5E",
            "SDValue": "0.00",
            "name": "common_bull_block"
        }, 
        {
            "SDbgColor": "#5BA452",
            "SDValue": "0.00",
            "name": "common_bull_retail"
        }
    ],
      POK:true,
      tabs: [
        { id: 1, title: 'common_quote' },
        { id: 2, title: 'common_profile' }
      ],
      selectedTab: QUOTE_TAB,
      instrument: {},
      spreadTable: [],
      lastSearchKeyWord: '',
      errorMessage: '',
      errorText:'',
      quoteData: {},
      searchLoading: false,
      transactionData: null,
      isAdd: false,
      chartStyles: null,
      load: true,
      isLoadingQuoteData: false,
      isLoadingConfirm:false,
      isAllowBuy:true,
      instrumentList: [],
      instrumentShow: false,
      market:'',
      historyList: [],
      historyShow: false,
      placeOrderShow: false,
      searchFlag: true,
      delayQuoteData: [
        {
          value: '-',
          id: 0,
          name: 'market_quote_open',
          field: 'open'
        },
        {
          value: '-',
          id: 1,
          name: 'market_quote_prev_close',
          field: 'prev'
        },
        {
          value: '-',
          id: 2,
          name: 'market_quote_high',
          field: 'high'
        },
        {
          value: '-',
          id: 3,
          name: 'market_quote_low',
          field: 'low'
        },
        {
          value: '-',
          id: 4,
          name: 'market_quote_tumover',
          field: 'turnover'
        },
        {
          value: '-',
          id: 5,
          name: 'market_quote_tumover_rate',
          field: 'turnoverRate',
          type: dataType.PERCENT
        },
        {
          value: '-',
          id: 6,
          name: 'common_volume',
          field: 'vol'
        },
        {
          value: '-',
          id: 7,
          name: 'market_quote_vol_rate',
          field: 'volRate'
        },
        {
          value: '-',
          id: 8,
          name: 'market_quote_minPriceDiff',
          field: 'minPriceDiff'
        },
        {
          value: '-',
          id: 9,
          name: 'common_lot_size',
          field: 'lotSize',
          type: dataType.NUMBER
        }
      ],
      watchlistData:[],
      serachList: '',
      searchdetailflag : true,
      avaiableQuantity :'',
      biddata:"",
      askdata:"",
      openMiniInfomation: false,
      stateBearBgColor:
      [
        {
            "SDbgColor": "#AF2D30",
            "SDValue": "0.00",
            "language": "大单"
        },
        {
            "SDbgColor": "#B00A32",
            "SDValue": "0.00",
            "language": "中单"
        },
        {
            "SDbgColor": "#D75153",
            "SDValue": "0.00",
            "language": "小单"
        }
    ],
      stateBullBgColor:[
        {
            "SDbgColor": "#3B6953",
            "SDValue": "0.00",
            "language": "大单"
        },
        {
            "SDbgColor": "#478A5E",
            "SDValue": "0.00",
            "language": "中单"
        },
        {
            "SDbgColor": "#5BA452",
            "SDValue": "0.00",
            "language": "小单"
        }
    ],
      avaiableBuyQuantity:'',
      buyingPower:'',
    }
    if(props.onRef){
      props.onRef(this);
    }
    this.searchInstrumentTime = Date.now()
    this.watchlistBtn = React.createRef();
    this.getWatchlistData = this.getWatchlistData.bind(this)
    this.openWatchlistDialog = this.openWatchlistDialog.bind(this)
  }

  render() {
    const {
      language,
      profile,
      index,
      markets,
      disableClose,
      alert,
      watchlistData,
      tradeInformation,
      placeOrder,
      chart,
      pieChart,
      userInfo,
      p_Identifier
    } = this.props;

    const {
      tabs,
      selectedTab,
      instrument,
      spreadTable,
      errorMessage,
      errorText,
      quoteData,
      searchLoading,
      transactionData,
      isAdd,
      load,
      chartStyles,
      isLoadingConfirm,
      isLoadingQuoteData,
      isAllowBuy,
      instrumentList,
      instrumentShow,
      historyList,
      historyShow,
      delayQuoteData,
      placeOrderShow,
      avaiableQuantity,
      biddata,
      askdata,
      openMiniInfomation,
      avaiableBuyQuantity,
      buyingPower,
    } = this.state;
    return (
      <React.Fragment>
        <div id="instrument-container" className='instrument-container'>
        { <div className='main-information-mini' style={{opacity:openMiniInfomation ? '1' : '0',visibility:openMiniInfomation ? 'unset' : 'hidden'}}>
                <span className='mini-name'>{instrument.marketID && instrument.instrumentID ? `${Converter.mappingWebSocketMarket(instrument.marketID)}.${instrument.instrumentID}` : ''}</span>
                <div className={classnames('mini-price', quoteData.classStyle)}>
                  <div className="current pointer"
                          onClick={() => this.copyPrice(quoteData.last)}>{quoteData.last}</div>
                  <div className="change-number">{quoteData.changeValue}</div>
                  <div className="change-percent">{quoteData.changePercent}</div>
                </div>
          </div> }
          {selectedTab === QUOTE_TAB &&
            <React.Fragment>
              <section  className='scroll-div' >
          <section className="search-input" style={ {marginBottom:15}}>
            <div className="market">
              <Dropdown
                style={{ height: '100%' }}
                innerRef={e => this.marketRef = e}
                selectedOptions={[markets[0]]}
                options={markets}
                onChange={this.handleChangeMarket}
                onMouseDown={(event)=>this.maintainfocus(event)}
              />
            </div>
            <div className="name" >
              <img src={SearchIcon} alt='search_icon' onClick={() => this.handleSearchInstrument()} />
              <input
                id='text'
                type="text"
                aria-label = {language.common_symbol}
                autocomplete="off"
                ref={e => this.instrumentInputRef = e}
                onBlur={() => this.handleSearchInstrument()}
                onKeyDown={this.handleInputKeyDown}
                onInput={this.handleSearchStocks}
                />
              <img src={RefreshIcon} alt='refresh_icon' onClick={this.handleRefresh} />
            </div>
            {
              instrumentShow && (<div className="search-dropdown" >
                {
                 instrumentList && instrumentList.map((item, index)=> {
                    return (
                      <div className="search-dropdown-item" key={index} onMouseDown={(event)=>this.maintainfocus(event)} onClick={() => this.handleSearchItemClick(item)}>
                        <div className="search-dropdown-item-left">{item.market}.{item.id}</div>
                        <div className="search-dropdown-item-right">
                        <span>{item.name}</span>
                          <img src={item.watch ? SearchWatchlistIcon : WatchlistAddIcon} alt='watchlist_icon' onMouseDown={(event)=>this.maintainfocus(event)} onClick={(event) => this.handleWatchClick(event, { ...item, index })} />
                        </div>
                      </div>
                    )
                  })
                }
              </div>)
            }
            {
              historyShow && (<div className="search-dropdown" >
                {
                  historyList.map((item, index)=> {
                    return (
                      <div className="search-dropdown-item" key={index} onMouseDown={(event)=>this.maintainfocus(event)} onClick={() => this.handleSearchItemClick(item)}>
                        <div className="search-dropdown-item-left">{item.market}.{item.id}</div>
                        <div className="search-dropdown-item-right">
                        <span>{item.name}</span>
                          <img src={item.watch ? SearchWatchlistIcon : WatchlistAddIcon} alt='watchlist_icon' onMouseDown={(event)=>this.maintainfocus(event)} onClick={(event) => this.handleWatchClick(event, { ...item, index })} />
                        </div>
                      </div>
                    )
                  })
                }
              </div>)
            }
            {/* {profile && userInfo['id'] && <div className="flex-box">
              <div className= {isAdd ? "add-btn-true" : "add-btn"}
                onClick={() => this.watchlistAction(isAdd ? VARIABLES_CONFIGS.DELETE : VARIABLES_CONFIGS.ADD)}
                style={{ backgroundColor: isAdd ? '' : '#424F5F' }}>
                <LoadingLayer load={load} type={LOADING_TYPE.SMALL_IMG} />
                <img src={isAdd ? WatchlistIcon : WatchlistAddIcon} alt='watchlist_icon' />
                {isAdd ? '' : <b>{language.watchlist_title}</b>}
              </div>
            </div>} */}
          </section>
          {instrument.updateTime && <section className="last-time">
            <span>{language.common_last_time}:</span>
            <span>{formatFunctions.dataFormat(instrument.updateTime, dataType.LONG_DATE)}</span>
          </section>}
          {errorMessage
            ? <section>
              <Tips isNoBgColor>
                {errorMessage}
              </Tips>
            </section>
            :
            (searchLoading
              ? <div className='search-loading'>
                <Icons.Loading style={{ width: 50, height: 50, margin: '0 auto' }} />
              </div>
              : <section className="main-information" >
                <div className="instrument-name">
                  <span>{instrument.marketID && instrument.instrumentID ? `${Converter.mappingWebSocketMarket(instrument.marketID)}.${instrument.instrumentID}` : ''}</span>
                  <span>{this.stockName(instrument)}</span>
                </div>
                {
                  <div className={classnames('instrument-price', quoteData.classStyle)}>
                    <div className='instrument-price-wrapper'>
                      {isLoadingQuoteData
                        ? <Icons.Loading />
                        : <React.Fragment>
                            <div className="current pointer"
                              onClick={() => this.copyPrice(quoteData.last)}>{quoteData.last}</div>
                            <div className="change-number">{quoteData.changeValue}</div>
                            <div className="change-percent">{quoteData.changePercent}</div>
                          </React.Fragment>
                      }
                    </div>
                    {
                       userInfo['id'] && watchlistData.custom && <div className="flex-box">
                        <div className={classnames("add-btn", isAdd && "is-add")} ref={this.watchlistBtn}
                          onClick={() => this.watchlistAction(isAdd ? VARIABLES_CONFIGS.DELETE : VARIABLES_CONFIGS.ADD)}
                          {...accessibilityFunctions.hasTabIndex()}
                          onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.watchlistAction(isAdd ? VARIABLES_CONFIGS.DELETE : VARIABLES_CONFIGS.ADD))}>
                          <LoadingLayer load={load} type={LOADING_TYPE.SMALL_IMG} />
                          <img src={isAdd ? WatchlistIcon : WatchlistAddIcon} alt='watchlist_icon' />
                          {isAdd ? '' : <b>{language.watchlist_title}</b>}
                        </div>
                      </div>
                    }
                  </div>
                }

              </section>
            )
          }
              {index && <section style={{ marginTop: 20 }}>
                <InstrumentIndex />
                {/* {instrument.updateTime && profile && <section className="last-time">
                  <span>{language.common_update}:</span>
                  <span>{formatFunctions.dataFormat(instrument.updateTime, dataType.LONG_DATE)}</span>
                </section>} */}
              </section>}
              <section className='bid-ask-wrapper'>
                <BidAsk handleQueueItemClick={this.handleQueueItemClick} setBidAskData={this.setBidAskData} />
              </section>
              {placeOrder && 
                <section className={classnames('place-order-section' , profile && !placeOrderShow && 'place-order-section-hide'  ,profile && placeOrderShow && 'place-order-section-open')}>
                  {  profile && placeOrder && placeOrderShow && <div className='place-order-header' onClick={() => this.setState({ placeOrderShow: false,errorText :''  })}>
                    <span className='place-order-title'>{language.menu_place_order}</span>
                    <span className='place-order-icon'><Icons.ArrowDown size={16}/></span>
                  </div> }
                  <PlaceOrderOption
                    innerRef={e => this.placeOrderOptionRef = e}
                    tradeInformation={tradeInformation}
                    spreadTable={spreadTable}
                    lotSize={instrument.lotsize}
                    showGrossAmount
                    currencyID={instrument.currencyID}
                    handleAllowBuy={this.handleAllowBuy.bind(this)}
                    quoteData = {quoteData}
                    avaiableQuantity = {avaiableQuantity}
                    avaiableBuyQuantity = {avaiableBuyQuantity}
                    buyingPower = {buyingPower}
                    biddata={biddata}
                    askdata={askdata}
                    key={this.state.POK}
                    setAvailableQuantity = {this.setAvailableQuantity}
                  />
                </section>}
                {pieChart && transactionData && iTradeEnv?.pages?.market?.init?.isOpenPieChart &&
              <section className={classnames('pie-chart-section',  placeOrderShow && 'pie-chart-section-hide')}>
                <InstrumentECharts innerRef={e => this.EChartsRef = e} data={transactionData} />
              </section>}
              { transactionData && pieChart && !placeOrderShow &&
              (<div>
                <div className='pie-chart-data' >
                <div className='bear-data' >
                   {((this.state?.bearBgColor && this.state?.bearBgColor.length != 0) ? this.state?.bearBgColor : this.state.stateBearBgColor).map((item,index)=>{
                     if(!item) return
                  return (
                    <div className='bear-chart-data' key={index}>
                      <div className='bear-name' >
                        <div style={{backgroundColor:item.bgColor}} className='bear-bgColor'  >  </div>
                        <div className='' > {this.state?.bearBgColor ?item.name : language[item.name]} </div>
                      </div>
                      <div className='bear-value' > { utilsFunction.numericalTransformation( Number(item.value),language)} </div>
                    </div>
                  )
                  })}
                </div>

                <div className='bull-data' >
                  {((this.state?.bullBgColor && this.state?.bullBgColor.length != 0)? this.state?.bullBgColor : this.state.stateBullBgColor).map((item,index)=>{
                    if(!item) return
                  return (
                    <div className='bull-chart-data' key={index}>
                      <div className='bull-name' >
                        <div style={{backgroundColor:item.bgColor}} className='bull-bgColor'  >  </div>
                        <div className='' > {this.state?.bearBgColor ?item.name : language[item.name]} </div>
                      </div>
                      <div className='bull-value' > { utilsFunction.numericalTransformation( Number(item.value),language)} </div>
                    </div>
                  )
                  })}
                </div>
                </div>
                <div className='flow'>
                  <div className='inflow' >
                    {language.market_capital_inflow + ':' }
                    <span style={{color:'red',lineHeight:'20px',margin:'0 0 0 5px'}} >  { this.state?.bearSum ?  utilsFunction.numericalTransformation( Number(this.state?.bearSum) ,language) : '0.00'}  </span>
                  </div>
                  <div className='flow-out'>
                    {language.market_capital_flow_out + ':'}
                    <span style={{color:'green',lineHeight:'20px',margin:'0 0 0 5px'}} >  { this.state?.bullSum ? utilsFunction.numericalTransformation(  Number(this.state?.bullSum) ,language) : '0.00'}  </span>
                  </div>
                </div>
              </div>
              )}
              { errorText && <Tips isNoBgColor>{errorText}</Tips>}
              </section>
              {/* <section id="chart-section" className={classnames('instrument-chart-section',  profile && placeOrderShow && 'instrument-chart-section-hide')}>
                {(chart && chartStyles) && <InstrumentLightweightCharts
                  chart_id={'instrument-small-chart'}
                  rangeSwitcherEnabled={false}
                  isMinimize={true}
                  styles={chartStyles}
                  cHeight={200}
                  volumeEnabled={false}
                  onMaximize={() => this.props.toggleChart()} />}
              </section> */}
              {/* {pieChart && transactionData && !chart && iTradeEnv?.pages?.market?.init?.isOpenPieChart &&
                <section className={classnames('pie-chart-section',  placeOrderShow && 'pie-chart-section-hide')}>
                  <InstrumentECharts innerRef={e => this.EChartsRef = e} data={transactionData} />
                </section>} */}
              
              
              <section className='bottom-item'>
              <div className="read-content">
                <span>{language.common_please_read} </span>
                <a target='_blank' href={riskDisclosureHrefs?.[language.lang] || '#'}>{language.common_the_risk_disclosure}</a> 
                <span> {language.common_and} </span>
                <a target='_blank' href={importantNoticeHrefs?.[language.lang] || '#'}>{language.common_important_statement}</a>
              </div>
              <section className='buy-sell-action' style={profile ? {marginTop:'15px'}:{marginTop:'autp'}}>
                {<button className='buy-btn'
                  onClick={() => this.handleOpenPlaceOrderDialog(true)}
                  disabled={!isAllowBuy}
                  style={isAllowBuy?{}:{cursor:'not-allowed',background:'#424F5F'}}>{language.common_buy}</button>}
                <button className='sell-btn' 
                 title={isLoadingConfirm ? language.icons_loading : language.common_sell}
                 onClick={() => this.handleOpenPlaceOrderDialog(false)}>{isLoadingConfirm ? <Icons.Loading /> : language.common_sell}</button>
              </section>
              </section>
              {/* {profile && <section className="action-section">
                <button className="toggle-chart-btn" onClick={this.props.toggleChart}>{language.chart_toggle}</button>
              </section>} */}
            </React.Fragment>}
          {/* {selectedTab === PROFILE_TAB && <InstrumentProfile />} */}
        </div>
      </React.Fragment>
    )
  }

  handleQueueItemClick = (data, type) =>  {
    if (this.props.profile && iTradeEnv?.pages?.market?.ctrl?.orderDialog) {
      this.handleOpenPlaceOrderDialog(type, { price: data.price, quantity: this.state.instrument.lotsize })
    } else if (this.placeOrderOptionRef) {
      const options = this.placeOrderOptionRef.getOptions();
      const price = data.price
      const quantity = options.quantity === '0' ? this.state.instrument.lotsize : options.quantity
      this.placeOrderOptionRef.setPrice(data.price);
      this.placeOrderOptionRef.setQuantity(quantity)
      if ( !this.state.placeOrderShow) {
        this.setState({ placeOrderShow: true })
      }
      setTimeout(this.placeOrderOptionRef.validateInput)
      this.placeOrderOptionRef.computeGrossAmount(price, quantity)
    }
  }

  formatNumber = (num) => {
    if (!num) return num
    let numArr = String(num).split(',')
    if (numArr.length === 5) {
      return `${numArr[0]}${numArr[1] === '000' ? '' : '.' + numArr[1]}T`
    } else if (numArr.length === 4) {
      return `${numArr[0]}${numArr[1] === '000' ? '' : '.' + numArr[1]}B`
    } else if (numArr.length === 3) {
      return `${numArr[0]}${numArr[1] === '000' ? '' : '.' + numArr[1]}M`
    } else {
      return num
    }
  }

  handleSearchStocks = utilsFunction.debounce((e) => {
      const { markets, language, currentMarket , watchlistData} = this.props
      const {custom} = watchlistData
      const params = {
        keywords: this.instrumentInputRef.value.trim(),
        realm: 'instrument',
        language: Converter.mappingWinVestLanguage(language.lang),
        size: 50
      }
      if(params.keywords == "" ){
        if(!this.state.historyShow){
            this.getQuoteHistory()
        }
      }else{
        this.setState({historyShow : false})
      
      if(this.state.searchFlag && this.instrumentInputRef.value){
      this.props.searchSystemService(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK && Array.isArray(res.result.instrument.data) && res.result.instrument.data.length) {
          const instrumentList = res.result.instrument.data.filter(item => item.market === currentMarket).map(item => {
              item.watch = Boolean(custom[0].flaggings.find(v => v.id === item.id && v.market === item.market))
              return item
          })
          if(this.state.searchFlag){
          this.setState({ instrumentList, instrumentShow: true })
        }
        } else {
          this.setState({ instrumentShow: false })
        }
      })
    }
  }
  }, 500)

  handleSearchItemClick = ({ id }) => {
    this.instrumentInputRef.value = id
    // this.setState({ instrumentShow: false ,historyShow:false})
    this.instrumentInputRef.blur()
  }

  handleWatchClick = (event, { index, id, market ,watch }) => {
    const {watchlistData} = this.props
    const {custom} = watchlistData
    const MarketID = Converter.mappingMDSMarketToStock(market)
    const InstrumentID = utilsFunction.instrumentIDZeroPadding(id)
    const stockData = `${InstrumentID}:${MarketID}`
    const name = custom[0].name
    const title = custom[0].title
    const items = []
    event.nativeEvent.stopImmediatePropagation();
    event.stopPropagation()
    if(custom[0].flaggings){
      for(let i=0;i<custom[0].flaggings.length;i++){
         items.push(custom[0].flaggings[i].id +':'+custom[0].flaggings[i].market)
       }
    } 
    if(!watch){
        items.push(stockData)
    }else{
      let i = items.indexOf(stockData)
      if(i>=0){
        items.splice(i,1)
      }
    }
      const item = items.join(',');
      const params={
        [WINVEST_PARAMS_JSON_FLAG.KEY] : WINVEST_PARAMS_JSON_FLAG.VALUE,
        return: 'Y',
        data: [
            {
                name: name,
                title:title,
                items:item
            }
        ],
      }
    const getWatchlistData = this.getWatchlistData.bind(this)
    this.props.manageWatchList(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
          if (this.state.instrumentShow) {
            const instrumentList = JSON.parse(JSON.stringify(this.state.instrumentList))
            instrumentList[index].watch = !instrumentList[index].watch
            this.setState({ instrumentList })
          } else {
            const historyList = JSON.parse(JSON.stringify(this.state.historyList))
            historyList[index].watch = !historyList[index].watch
            this.setState({ historyList })
          }
          getWatchlistData(()=>{
            this.props.toggleRefreshMarket(true)
          })
    }
    })

  }

  copyPrice = (price) => {
    const orderType = this.placeOrderOptionRef.getOptions().orderType.value;
    if(utilsFunction.isOrderNeedEnterPrice(orderType)){
      if (this.props.profile) {
        this.handleOpenPlaceOrderDialog(true, { price, quantity: this.state.instrument.lotsize })
        return
      }
      this.placeOrderOptionRef.setPrice(price);
      this.placeOrderOptionRef.handleChangePrice(price)
      this.placeOrderOptionRef.focusPrice();
    }
    const { quantity } = this.placeOrderOptionRef.getOptions();
    this.placeOrderOptionRef.setQuantity(quantity === '0' ? this.state.instrument.lotsize : quantity)
  }

  handleRefresh = () => {
    this.handleSearchInstrument(true)
  }

  handleChangeMarket = (market) => {
    const tradeConfig = this.props.tradeConfigSettings
    const marketID = market[0].value
    this.props.changeMarket(marketID, this.props.tradeDateInfoList, tradeConfig)
    this.setState({market : marketID})
  }

  stockName(instrument) {
    const { language } = this.props
    switch (language.lang) {
      case APP_LANGUAGE_SUPPORTS[0].id: {
        return instrument['instrumentChineseName']
      }
      case APP_LANGUAGE_SUPPORTS[1].id: {
        return instrument['instrumentChineseName']
      }
      default: {
        return instrument['instrumentName']
      }
    }
  }

  handleGetSpreadTable(spreadTableCode) {
    const { language } = this.props;
    const params = {
      [PARAMS.SPREAD_TABLE_CODE]: spreadTableCode,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.props.getSpreadTable(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          this.setState({ spreadTable: res.result.spreadTableList })
        }
      }
    })
  }

  handleSearchInstrument = utilsFunction.debounce((isRefresh = false, isGetWatch = false) => {
    const currentSearchInstrumentTime = Date.now()
    this.searchInstrumentTime = currentSearchInstrumentTime
    clearTimeout(this.timeOutRef)
    this.setState({ errorMessage: '',errorText:'' ,instrumentShow : false ,historyShow :false , searchFlag : false , searchdetailflag : false ,quoteData :''})
    const { language, currentMarket, userInfo } = this.props;
    const { id } = userInfo;
    if(this.instrumentInputRef?.value?.trim() === '' && this.state.historyShow){
      this.instrumentInputRef.value = this.state.historyList[0]?.id;
    }
    if(!currentMarket) return
    let keyword = this.instrumentInputRef?.value;
    // const keywordIndex = keyword.split('').findIndex(i => i !== '0');
    // if (keywordIndex > -1) {
    //   keyword = keyword.substr(keywordIndex);
    // }
    if(currentMarket ==='SZMK'   && keyword?.length < 6){
      while(keyword?.length < 6){
        keyword = '0' + keyword
      }
    }
    // if (keyword === this.state.lastSearchKeyWord) return;
    if (keyword === '') {
      this.setState({ errorMessage: language['instrument_required'] })
    }
    if (isRefresh || keyword) {
      // if (isRefresh || (keyword && keyword !== this.state.lastSearchKeyWord)) {
      this.setState({ searchLoading: false })
      const params = {
        [PARAMS.MARKET_ID]:  currentMarket,
        [PARAMS.INSTRUMENT_ID]: keyword.trim(),
        [PARAMS.LANGUAGE]: language.lang
      }
      if(Number(keyword) < 10000 || (Number(keyword)>29999 && Number(keyword)< 99999)  ){
        this.props.setNCstock({NCstockCode:keyword.trim(),NCmarketID:currentMarket},()=>{})
      }
      this.props.getInstrumentDetail(params, res => {
        if (this.searchInstrumentTime === currentSearchInstrumentTime && res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ instrument: res.result, lastSearchKeyWord: keyword });
            this.instrumentInputRef.value = res.result.instrumentID;
            if (id) {
              // this.getQuoteHistory({ stockCode: this.instrumentInputRef.value, marketID: currentMarket })
              this.props.manageQuoteHistory({ keyword: this.instrumentInputRef.value + ':' + currentMarket}, res => {
                if(res.status === SERVICES_RESP.STATUS_OK){
                  if(this.props.profile){
                    this.props.refreshhistory()
                  }
                }
              })
            }
            this.handleGetSpreadTable(res.result.spreadTableCode);
            if(currentMarket === "USEX"){
              this.setState({ isLoadingQuoteData: true })

              let requestState = 'pending'
              const temporaryData = {}

              const renderQuoteDataFunc = (data) => {
                const quoteData = Converter.computeQuoteData({ last: data.last, prev: data.prev })
                this.setState({ quoteData, isLoadingQuoteData: false, searchLoading: false, searchdetailflag:true })
              }

              stockActions.getStatisticsAction({symbols: [{ exchangeID: Converter.mappingWebSocketMarket(currentMarket), key: res.result.instrumentID }]}, statisticsRes => {
                if (statisticsRes.rtnCode) return 
                temporaryData.last = statisticsRes.last
                stockActions.getClosingPriceAction({symbols: [{ exchangeID: Converter.mappingWebSocketMarket(currentMarket), key: res.result.instrumentID }]}, closingPriceRes => {
                  if (closingPriceRes.rtnCode) return
                  temporaryData.prev = closingPriceRes.closingPrice
                  requestState = 'success'
                  renderQuoteDataFunc({ last: statisticsRes.last, prev: closingPriceRes.closingPrice })
                })
              })

              this.timeOutRef = setTimeout(() => {
                if (requestState === 'pending') {
                  renderQuoteDataFunc(temporaryData)
                  clearTimeout(this.timeOutRef)
                }
              }, 3500)
              
              // this.setState({ searchLoading: false })             
            } else if (currentMarket === 'SZMK') {
              this.setState({ isLoadingQuoteData: true })
              const params = { symbols: [{ exchangeID: Converter.mappingWebSocketMarket(currentMarket), key: res.result.instrumentID }], sessID: this.props.mdsToken }
              this.props.getDetailPriceInfo(params, quetores => {
                if (quetores.rtnCode) {
                  return this.setState({ isLoadingQuoteData: false, quoteData: Converter.computeQuoteData({ last: null, prev: null }) })
                }
                const quoteData = Converter.computeQuoteData(quetores)
                this.setState({ quoteData, isLoadingQuoteData: false, searchLoading: false })
              }, quetoresErr => {
                if (quetoresErr.rtnCode) {
                  return this.setState({ isLoadingQuoteData: false, quoteData: Converter.computeQuoteData({ last: null, prev: null }) })
                }
              })

            } else{
            // if (this.placeOrderOptionRef) {
            //     this.placeOrderOptionRef.reset()
            // };
            
            this.setState({ isLoadingQuoteData: true })

              this.props.getQuote({ exchangeID: currentMarket, instrumentID: res.result.instrumentID }, res => {
                if(res.rtnCode){
                  this.setState({ isLoadingQuoteData: false, quoteData: Converter.computeQuoteData({ last: null, prev: null }) })
                  return
                }
                const quoteData = Converter.computeQuoteData(res)
                this.setState({ quoteData, isLoadingQuoteData: false, searchLoading: false, searchdetailflag:true })
              })

            }

            this.onChartPrepare();
            this.isAdd()
            this.setAvailableQuantity()
          if (isGetWatch) {
            this.getWatchlistData()
           }
          }else if(res.result.errorCode === SERVICES_RESP.SEARCH_ERROR_CODE){
            this.reSetDelayQuoteData()
            if(res.result.errorMessage){
              this.setState({ errorMessage: res.result.errorMessage, searchLoading: false ,searchdetailflag:true ,instrument:''})
            }else{
              this.setState({ errorMessage: language.instrument_not_found_message, searchLoading: false ,searchdetailflag:true,instrument:''})
            }
          }
          else {
            this.reSetDelayQuoteData()
            this.setState({ errorMessage: res.result.errorMessage, searchLoading: false })
          }
        }
      })
    }
  })

  reSetDelayQuoteData(){
    let originData = this.state.delayQuoteData;
    let detailData = originData.map(item => {
      item.value = '-'
      return item
    })
    this.setState({
      delayQuoteData:detailData
    })
  }

  handleInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      // this.handleSearchInstrument();
      this.instrumentInputRef.blur()
      this.setState({ instrumentShow: false ,searchFlag : false})
    }else{
      this.setState({ searchFlag: true })
    }
  }

  getQuoteHistory() {
    const { userInfo , language} = this.props;
    const { id } = userInfo;
    if (id) {
      let data = [];
      let quoteHistoryData = [];
      let historyList = []
      const {watchlistData} = this.props
      const {custom} = watchlistData
      // this.props.getWatchlist({ uuid: id }, res => {
      //   this.setState({
      //     watchlistData : res.result
      //   })
      // })
      const params = {
        uuid :id,
        realm: 'instrument',
        language: Converter.mappingWinVestLanguage(language.lang),
      }
      this.props.getQuoteHistory(params, res => {
        if (res.length !== 0) {
          quoteHistoryData = res.instrument;
          quoteHistoryData.map(item => {
            data.push(item.split(':'))
          })
          data.map(item=>{
            item.market = item[1]
            item.id = item[0]
            item.name = item[2]
            if(item.name ==='') return
            item.watch = Boolean(custom[0].flaggings.find(v => v.id === item.id && v.market === item.market))
            let {id , market ,name,watch} = item
            let data = {id,market,name,watch} 
            historyList.push(data)
          })
          this.setState({historyList:historyList , historyShow:true})
        }
      })
    }
  }

  getTradeDistributionData = () => {
    const { marketParams, language } = this.props;
    const { marketID, stockCode } = marketParams;
    if (!(marketID || stockCode)) { this.setState({bearBgColor:null,bullBgColor:null,bearSum:0.00,bullSum:0.00,transactionData: []}) ; return}
    const { location } = history
    const historyState = location.state
    let params = {
      symbols: [
        {
          exchangeID: Converter.mappingWebSocketMarket(marketID),
          key: Converter.mappingStockCode(stockCode )
        }
      ]
    }
    // if (historyState) {
    //    params = {
    //     symbols: [
    //       {
    //         exchangeID: Converter.mappingWebSocketMarket(historyState.marketID ),
    //         key: Converter.mappingStockCode(historyState.StockID )
    //       }
    //     ]
    //   }
    // }else if(!(marketID || stockCode)){
    //   return
    // }else{
    //   params = {
    //     symbols: [
    //       {
    //         exchangeID: Converter.mappingWebSocketMarket(marketID),
    //         key: Converter.mappingStockCode(stockCode )
    //       }
    //     ]
    //   }
    // }
    this.props.getTradeDistribution(params, res => {
      if (res.rtnCode) {
        this.setState({ transactionData: [] })
        return
      }
      if (res.bullUltraBlock) {
        const { transactionData } = this.state;
        let ResData = [
          { value: res.bullUltraBlock.turnover, name: this.props.language.common_bull_ultra_block, bgColor: '#3B6953',itemStyle: {color:"#3B6953"} },
          { value: res.bullBlock.turnover, name: this.props.language.common_bull_block, bgColor: '#478A5E' ,itemStyle: {color:"#478A5E"}},
          { value: res.bullRetail.turnover, name: this.props.language.common_bull_retail, bgColor: '#5BA452' ,itemStyle: {color:"#5BA452"}},
          { value: res.bearRetail.turnover, name: this.props.language.common_bear_retail, bgColor: '#D75153' ,itemStyle: {color:"#D75153"}},
          { value: res.bearBlock.turnover, name: this.props.language.common_bear_block, bgColor: '#B00A32' ,itemStyle: {color:"#B00A32"}},
          { value: res.bearUltraBlock.turnover, name: this.props.language.common_bear_ultra_block, bgColor: '#AF2D30',itemStyle: {color:"#AF2D30"} },
        ]

        if (transactionData && this.EChartsRef) {
          this.setState({
            transactionData: ResData
          },()=>{
            let bullName = [this.props.language.common_bull_ultra_block,this.props.language.common_bull_block,this.props.language.common_bull_retail]
            let bearName = ['#D75153','#B00A32','#AF2D30']
            let bullBgColor=[]
            let bearBgColor=[]
            for(let i = 0;i< this.state.transactionData.length;i++){
              bullBgColor.push(this.state.transactionData.find(item => item.name == bullName[i]))
              bearBgColor.push(this.state.transactionData.find(item => item.bgColor == bearName[i]))
            }
          bearBgColor.sort((a,b)=> { return b.value-a.value})
          this.setState({bullBgColor,bearBgColor},()=>{
            let bullSum = 0.00
            let bearSum = 0.00
            this.state.bullBgColor.map((item)=>{
              if(!item?.value) return
              bullSum += Number(item?.value)
            })
            this.state.bearBgColor.map((item)=>{
              if(!item?.value) return
              bearSum += Number(item?.value)
            })
            this.setState({bullSum,bearSum},()=>{
            })
          })
          })
          this.EChartsRef.setEChartPieData({
            series: [{
              name: language.market_distribution_title,
              data: ResData
            }]
          })
        } else {
          this.setState({
            transactionData: ResData
          },()=>{
            let bullName = [this.props.language.common_bull_ultra_block,this.props.language.common_bull_block,this.props.language.common_bull_retail]
            let bearName = ['#D75153','#B00A32','#AF2D30']
            let bullBgColor=[]
            let bearBgColor=[]
            for(let i = 0;i< this.state.transactionData.length;i++){
              bullBgColor.push(this.state.transactionData.find(item => item.name == bullName[i]))
              bearBgColor.push(this.state.transactionData.find(item => item.bgColor == bearName[i]))
            }
          bearBgColor.sort((a,b)=> { return b.value-a.value})
          this.setState({bullBgColor,bearBgColor},()=>{
            let bullSum = 0.00
            let bearSum = 0.00
            this.state.bullBgColor.map((item)=>{
              if(!item?.value) return
              bullSum += Number(item?.value)
            })
            this.state.bearBgColor.map((item)=>{
              if(!item?.value) return
              bearSum += Number(item?.value)
            })
            this.setState({bullSum,bearSum},()=>{
            })
          })
          })
        }
      }
    })
  }

  handleOpenPlaceOrderDialog = async (direction, initData = {}) => {
    const { currentTradingAccount ,profile } = this.props;
    if ( !this.state.placeOrderShow  &&  iTradeEnv?.pages?.market?.ctrl?.placeOrder && profile) {
      this.setState({ placeOrderShow: true })
      return
    }
    this.setState({errorText:null,errorMessage:null},async ()=>{
      if (!this.state.errorMessage) {
        let options = '', orderData = {};
        if ((this.placeOrderOptionRef && !profile) || iTradeEnv?.pages?.market?.ctrl?.placeOrder) {
          options = this.placeOrderOptionRef.getOptions();
          const stopPrice = options.stopPrice ?? '0'
          if(utilsFunction.isOrderNeedEnterPrice(options.orderType.value)){
            if (options.price === '0' || options.quantity === '0' ||
              (options.orderType.value === ORDER_TYPE.TRIGGER_ORDER.value && stopPrice === '0')) {
              this.placeOrderOptionRef.validateInput();
              return;
            }
          } else {
            if (options.quantity === '0' ||
              (options.orderType.value === ORDER_TYPE.TRIGGER_ORDER.value && stopPrice === '0')) {
              this.placeOrderOptionRef.validateInput();
              return;
            }
          }
          if(!(options.quantity % this.state.instrument.lotsize == 0)){
            this.setState({ errorText:this.props.language.HKSFOE00021.format(this.state.instrument.lotsize) })
            return;
          } else if (!direction){
            let qty = parseInt(options.quantity)
            await this.getAvailableQuantity(qty);
          }else{
            this.setState({
              errorText:''
            })
          }
          orderData = {
            ...this.state.instrument,
            ...options,
            spreadTable: this.state.spreadTable,
            quoteData: this.state.quoteData,
            isAllowBuy:true
          }
          if(options.orderType.value === ORDER_TYPE.AT_AUCTION.value){
            orderData = {
              ...this.state.instrument,
              ...options,
              spreadTable: this.state.spreadTable,
              quoteData: this.state.quoteData,
              isAllowBuy:false
            }
          }
        } else {
          orderData = {
            ...this.state.instrument,
            spreadTable: this.state.spreadTable,
            quoteData: this.state.quoteData
          }
        }
        if(this.state.errorText){
          return
        }
        if(this.props.TradeDashboard || iTradeEnv?.pages?.market?.ctrl?.placeOrder){
          orderData.isBuy = direction
          orderData.cashAccount = currentTradingAccount.clientID
          openOrderConfirm(orderData, (isCloseDialog = true) => {
          })
        }else{
          openPlaceOrderDialog(direction, Object.assign({}, orderData, initData))
        }
      }
    })
  }

  getAvailableQuantity = (qty) => {
    return new Promise(resolve => {
      this.setState({ isLoadingConfirm: true })
      const { language, currentTradingAccount, currentMarket } = this.props;
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.MARKET_ID]: currentMarket,
        [PARAMS.INSTRUMENT_ID]: this.instrumentInputRef.value,
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getAvailableQuantity(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            if (res.result.avaiableQuantity == 0) {
              this.setState({ errorText: language.error_message_available_qty_zero})
            } else if (qty > res.result.avaiableQuantity) {
              this.setState({ errorText: language.error_message_more_than_available_qty})
            } else {
              this.setState({
                errorText: ''
              })
            }
          }
        }
        this.setState({ isLoadingConfirm: false })
        resolve()
      })
    })
  }

  handleChangeTab = (tab) => {
    switch (tab.main.title) {
      case 'common_quote': {
        this.setState({ selectedTab: QUOTE_TAB })
        break;
      }
      case 'common_profile': {
        this.setState({ selectedTab: PROFILE_TAB })
        break;
      }
      default:
        break;
    }
  }

  setAvailableQuantity = () => {
      const { language, currentTradingAccount, currentMarket } = this.props;
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.MARKET_ID]: currentMarket,
        [PARAMS.INSTRUMENT_ID]: this.instrumentInputRef.value,
        [PARAMS.LANGUAGE]: language.lang,
      }
      this.props.getAvailableQuantity(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({avaiableQuantity : res.result.avaiableQuantity})
          }
        }
        resolve()
      })
      this.props.EnquiryBuyingPower(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({avaiableBuyQuantity : res.result.bpestimate, buyingPower : res.result.buyingPower})
          }
        }
        resolve()
      })
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  componentDidMount() {
    // this.getWatchlistData()
    const {markets,currentMarket} = this.props
    const { location } = history
    const historyState = location.state
    const tradeConfig = this.props.tradeConfigSettings
    const marketID = this.props.markets[0]?.value
    if(historyState){
      this.instrumentInputRef.value = historyState.StockID;
      if(JSON.stringify(tradeConfig) !='{}'){
        this.props.changeMarket(historyState.marketID, this.props.tradeDateInfoList, tradeConfig)
        this.marketRef.setValue([markets.filter(v => v.value === currentMarket)[0]])
      }
    }else{
      this.instrumentInputRef.value = this.props.marketParams.stockCode ? this.props.marketParams.stockCode : '00001';
      this.marketRef.setValue([markets.filter(v => v.value === currentMarket)[0]])
      // marketID && this.props.changeMarket(marketID, this.props.tradeDateInfoList, tradeConfig)
    }
    this.isAdd()
    if (this.instrumentInputRef.value && this.instrumentInputRef.value !== '') {
      this.handleSearchInstrument();
    }
    this.getTradeDistributionData();
    if (this.props.chart) {
      this.onChartPrepare();
    }
    if (this.props.userInfo) {
      this.setState({
        load: false
      })
    }
    document.getElementsByClassName('scroll-div')[0].addEventListener('scroll', utilsFunction.throttle(this.scrollBar,500,true))
  }
  scrollBar=(e)=>{
    if(e.target.scrollTop>=140){
      this.setState({openMiniInfomation:true})
    }else{
      this.setState({openMiniInfomation:false})
    }
  }
  componentDidUpdate(preProps) {
    const { isNeedRefresh, marketParams, currentMarket, language, chart, userInfo, watchlistData ,markets , priceParams,currentTradingAccount} = this.props;
    if((this.props.language != preProps.language) || (this.props.theme != preProps.theme) ){
      this.getTradeDistributionData()
    }
    if(this.props.cashAccountData != preProps.cashAccountData){
      this.setState({POK:!this.state.POK})
    }
    if(marketParams.stockCode != preProps.marketParams.stockCode){
      this.getTradeDistributionData();
    }
    if (marketParams && preProps.marketParams.stockCode !== marketParams.stockCode && preProps.marketParams.stockCode && JSON.stringify(marketParams) !='{}') {
      this.isAdd()
      this.setState({POK:!this.state.POK})
      if (marketParams.marketID === 'USEX') {
        this.instrumentInputRef.value = this.props.marketParams.stockCode;
      } else {
        const stockCode = utilsFunction.instrumentIDZeroPadding(this.props.marketParams.stockCode ? this.props.marketParams.stockCode : '1')
        this.instrumentInputRef.value = stockCode;
      }
      if(JSON.stringify(preProps.currentTradingAccount) !='{}') this.setAvailableQuantity()
    }
    if ( preProps.marketParams.stockCode && preProps.marketParams.stockCode !== marketParams.stockCode) {
      if(this.state.searchdetailflag) this.handleSearchInstrument(false, false)
    }
    if (chart !== preProps.chart) {
      this.onChartPrepare();
      this.getWatchlistData()
    }
    if (userInfo && preProps.userInfo !== userInfo && JSON.stringify(preProps.userInfo)!='{}') {
      this.setState({
        load: false
      })
      this.getWatchlistData()
    }
    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      this.props.toggleRefreshMarket(false);
    }
    if (watchlistData && preProps.watchlistData !== watchlistData) {
      this.isAdd();
    }
    if (currentMarket && preProps.currentMarket !== currentMarket) {
      this.marketRef.setValue([markets.filter(v => v.value === currentMarket)[0]])
      this.handleSearchInstrument(false, false)
    }
    // if(currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount){
    //   // if(JSON.stringify(preProps.currentTradingAccount)==='{}') return
    //   this.setAvailableQuantity()
    // }
    if(JSON.stringify(this.props.tradeDateInfoList) !='[]' && preProps.tradeDateInfoList !== this.props.tradeDateInfoList){
      const { location } = history
      const historyState = location.state
      if(historyState){
        this.props.changeMarket(historyState?.marketID, this.props.tradeDateInfoList, this.props.tradeConfigSettings)
      }
    }
    if (Object.keys(priceParams).length && JSON.stringify(preProps.priceParams) !== JSON.stringify(priceParams)) {
      let params = {
        stockCode:priceParams.instrumentID,
        marketID:priceParams.marketID
      }
      const tradeConfig = this.props.tradeConfigSettings
      this.props.changeMarket(priceParams.marketID, this.props.tradeDateInfoList, tradeConfig)
      this.placeOrderOptionRef.setPrice(0)
      this.placeOrderOptionRef.setQuantity(0)
      this.props.setStock(params, ()=>{
        if (priceParams.price !== '-') {
          this.placeOrderOptionRef.setPrice(priceParams.price)
        }
        if (priceParams.quantity !== '-') {
          this.placeOrderOptionRef.setQuantity(priceParams.quantity)
        }
      })
    }
    // if(language && preProps.language !==language){
    //   this.getWatchlistData(()=>{
    //     this.props.toggleRefreshMarket(true)
    //   })
    // }
  }

  componentWillUnmount() {
    document.getElementsByClassName('scroll-div')[0].removeEventListener('scroll', utilsFunction.throttle(this.scrollBar,500,true))
    this.setState = () => {
      return
    }
  }

  getWatchlistData(callback) {
    const { marketParams, userInfo } = this.props;
    const { id } = userInfo;
    if (id) {
      this.props.getWatchlist({ uuid: id }, res => {
        if (res){
          this.isAdd()
          this.setState({
            watchlistData : res.result
          })
          typeof callback === 'function' && callback()
        }else{
          this.setState({load:false})
        }
      })
    }
  }

  isAdd = () => {
    const { marketParams , watchlistData } = this.props;
    const { stockCode, marketID } = marketParams;
    let stop = '';
    watchlistData.custom[0]?.flaggings?.map(item => {
      if (item.id === stockCode && item.market === marketID) {
        stop = true
        return
      }
    })
    if (stop) {
      this.setState({
        isAdd: true
      })
    } else {
      this.setState({
        isAdd: false
      })
    }
  }

  watchlistAction=(action)=>{
    this.setState({load:true})
    if (this.state.load) return
    // const { watchlistData } = this.state
    const { marketParams ,watchlistData } = this.props;
    const { custom } = watchlistData
    const { stockCode, marketID } = marketParams;
    const name = custom[0].name
    const title = custom[0].title
    const items = []
    if(custom[0].flaggings){
      for(let i=0;i<custom[0].flaggings.length;i++){
         items.push(custom[0].flaggings[i].id +':'+custom[0].flaggings[i].market)
       }
    } 
    if(action == VARIABLES_CONFIGS.ADD){
        items.push(stockCode + ":" + marketID)
    }else{
      let stockData = stockCode + ":" + marketID
      let i = items.indexOf(stockData)
      if(i>=0){
        items.splice(i,1)
      }
    }
      const item = items.join(',');
      const params={
        [WINVEST_PARAMS_JSON_FLAG.KEY] : WINVEST_PARAMS_JSON_FLAG.VALUE,
        return: 'Y',
        data: [
            {
                name: name,
                title:title,
                items:item
            }
        ],
      }
      this.props.manageWatchList(params,res=>{
        if (res.status === SERVICES_RESP.STATUS_OK && Array.isArray(res.result)) {
          if (action === VARIABLES_CONFIGS.ADD) {
            if (res.result.find(v => v.name === name && Array.isArray(v.flaggings) && v.flaggings.find(c => c.market === marketID && c.id === stockCode))) {
              this.getWatchlistData(() => {
                this.openWatchlistDialog(action)
                this.props.toggleRefreshMarket(true)
              })
            } else {
              this.setState({load: false})
            }
          } else {
            this.getWatchlistData(() => {
              this.openWatchlistDialog(action)
              this.props.toggleRefreshMarket(true)
            })
          }
        }else{
          this.setState({load: false})
        }
      })
    
  }

  openWatchlistDialog = (action) => {
    const pos = this.watchlistBtn.current.getBoundingClientRect()
    const p = {
      top: pos.top,
      left: action === VARIABLES_CONFIGS.ADD ? pos.left - 22 : pos.left,
      width: pos.width,
      height: pos.height
    }
    openWatchlistPrompt(p,action)
    this.setState({load:false})
  }

  onChartPrepare = () => {
    const pDivWH = getElementWidthHeightById('instrument-container');
    let chartWH = {
      width: pDivWH.width - 30,
      height: 320
    }
    this.setState({
      chartStyles: chartWH
    })
  }

  handleAllowBuy = (orderType) =>{
    if(orderType[0].value === ORDER_TYPE.AT_AUCTION.value ){
      this.setState({
        isAllowBuy:false
      })
    }else{
      this.setState({
        isAllowBuy:true
      })
    }
  }
  
  maintainfocus=(event)=>{
    event.preventDefault()
  }

  setBidAskData=(biddata,askdata)=>{
    this.setState({
      biddata:biddata,
      askdata:askdata
    })
  }
}

Instrument.defaultProps = {
  profile: null,
  index: false,
  disableClose: false,
  alert: null,
  watchlist: null,
  tradeInformation: null,
  placeOrder: true,
  chart: null,
  pieChart: false,
  p_Identifier: null,
  TradeDashboard:false
}

export default connect(
  state => ({
    theme: state.app.theme,
    language: state.app.language,
    currentMarket: state.trade.currentMarket,
    markets: state.trade.markets,
    marketParams: state.trade.marketParams,
    userInfo: state.user.userInfo,
    isNeedRefresh: state.refresh.marketAction,
    watchlistData: state.user.watchlist,
    tradeConfigSettings: state.trade.tradeConfigSettings,
    orderTypes: state.trade.orderTypes,
    tradeDateInfoList: state.trade.tradeDateInfoList,
    currentTradingAccount: state.trade.currentTradingAccount,
    priceParams: state.trade.priceParams,
    mdsToken: state.trade.mdsToken,
  }),
  dispatch => ({
    getInstrumentDetail: (p, res) => dispatch(stockActions.getInstrumentDetailAction(p, res)),
    getSpreadTable: (p, res) => dispatch(stockActions.getSpreadTableAction(p, res)),
    getQuote: (p, res) => stockActions.enquireInstrumentInfoAction(p, res),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    getTradeDistribution: (p, res) => dispatch(stockActions.getTradeDistributionAction(p, res)),
    getWatchlist: (p, res) => dispatch(userActions.getInstrumentWatchlistAction(p, res)),
    getQuoteHistory: (p, c) => dispatch(userActions.getQuoteHistoryAction(p, c)),
    manageQuoteHistory: (p, res) => dispatch(userActions.manageQuoteHistoryAction(p, res)),
    toggleRefreshMarket: (p) => dispatch({
      type: REFRESH_DATA.MARKET_ACTION,
      value: p
    }),
    getAvailableQuantity: (p, res) => dispatch(accountActions.getAvailableQuantityAction(p, res)),
    changeMarket: (p, p2, res) => dispatch(stockActions.changeMarketAction(p, p2, res)),
    searchSystemService: (p, res) => dispatch(forumActions.searchSystemAction(p, res)),
    manageWatchList: (p, res) => dispatch(userActions.manageWatchlistAction(p, res)),
    EnquiryBuyingPower: (p, res) => dispatch(accountActions.EnquiryBuyingPowerAction(p, res)),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    setNCstock:(p,res)=> dispatch(stockActions.setNoChangeMarketStockAction(p,res)),
  })
)(Instrument)